// extracted by mini-css-extract-plugin
export default {"HasTags":"HasTags_HasTags__YgM3u","Left":"HasTags_Left__ehW-3","Tag":"HasTags_Tag__qn99y","Right":"HasTags_Right__6VdPS","Wrapper":"HasTags_Wrapper__18RcR"};